// Okunmamis bildirim sayisi icin modul seviyesinde paylasilan deger.
// Tek kaynak NotificationBell'in mevcut polling dongusudur; menu girdisi yalnizca dinler
// (ikinci bir polling dongusu yoktur). Yalnizca sayi tutulur; icerik veya kimlik tutulmaz.
let unreadCount = 0;
const listeners = new Set();

export const getUnreadCount = () => unreadCount;

export const setUnreadCount = value => {
  const next = Number(value) > 0 ? Number(value) : 0;
  if (next === unreadCount) return;
  unreadCount = next;
  listeners.forEach(fn => fn(unreadCount));
};

export const subscribeUnreadCount = fn => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};
